import React from 'react';
import { Link } from 'react-router-dom';
import V2SEO from '../components/V2SEO';

const NotFound = () => (
  <>
    <V2SEO
      title="Page Not Found"
      description="That page doesn't exist. Explore Cosmik Drones' aerial cinematography services, portfolio, and blog."
      path="/404"
      noindex
    />
    <section className="v2-svc-hero">
      <div className="v2-container" style={{ textAlign: 'center' }}>
        <span className="v2-eyebrow">404</span>
        <h1>Page Not Found</h1>
        <p className="v2-prose" style={{ margin: '1.2rem auto' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div style={{ display: 'flex', gap: '0.7rem', flexWrap: 'wrap', justifyContent: 'center', marginTop: '1.6rem' }}>
          <Link to="/" className="v2-btn v2-btn--primary">Home</Link>
          <Link to="/portfolio" className="v2-btn v2-btn--ghost">Portfolio</Link>
          <Link to="/services" className="v2-btn v2-btn--ghost">Services</Link>
          <Link to="/contact" className="v2-btn v2-btn--ghost">Contact</Link>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
